module.exports = "<template> <input type=week value.bind=field.value> </template> ";